import { lazy, Suspense } from "react";
import AuthGuard from "./AuthGuard";
import { RouteType } from "./MainRoutes";
import { Backdrop, CircularProgress } from "@mui/material";
const LoginPage = lazy(() => import("../pages/login/Login"));

const Loading = () => (
  <Backdrop
    sx={{
      color: (theme) => theme.palette.primary.contrastText,
      zIndex: (theme) => theme.zIndex.drawer + 1,
    }}
    open={true} // Ensure backdrop is always visible during loading
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export const AuthRoutes: RouteType = {
  path: '',
  children: [
    {
      path: 'login',
      element: <Suspense fallback={<Loading />}>
        <AuthGuard>
          <LoginPage />
        </AuthGuard>,
      </Suspense>
    },
  ],
}